<template>
  <!-- 消耗品発送検索 -->
  <div id="AppRegularDisposablesSearchResult">
    <!-- 検索結果 -->
    <section>
      <div class="columns">
        <div class="column">
          <b-field horizontal label="検索結果" style="float: right; white-space: nowrap;">
            <b-select position="is-right" v-model="perPage">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div>
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="defaultSortDirection"
          default-sort="parCode"
          detailed
          checkable
          :checked-rows.sync="checkedRows"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          style="border-bottom:solid 1px; border-color:lightgrey;"
        >
          <template slot-scope="props">
            <b-table-column
              field="patientCode"
              label="患者コード"
              sortable
              centered
            >{{ props.row.patientCode }}</b-table-column>
            <b-table-column
              field="patientName"
              label="患者名"
              sortable
              centered
            >{{ props.row.patientName }}</b-table-column>
            <b-table-column
              field="patientPhone"
              label="電話番号"
              sortable
              centered
            >{{ props.row.patientPhone }}</b-table-column>
            <b-table-column field="status" label="ステータス" sortable centered>
              <span
                :class="['tag',
                       {'is-success':props.row.status == 1 && props.row.untargetedFlag == false},
                       {'is-danger':props.row.status == 0 && props.row.untargetedFlag == false},
                       {'is-warning':props.row.untargetedFlag == true}
                       ]"
                style="width:110px; height:35px; font-size:17px"
              >{{ props.row.status | regularDisposablesStatusFilter(props.row.untargetedFlag) }}</span>
            </b-table-column>
            <b-table-column field="officeName" label="営業所" sortable centered>
              <span
                v-for="officeName in getOfficeName(props.row.officeName)"
                :value="officeName"
                :key="officeName"
              >
                {{ officeName }}
                <br />
              </span>
            </b-table-column>
            <b-table-column label="発送登録" sortable centered>
              <b-button
                v-on:click="regulardisposablesOrder(props.row.patientCode,props.row.patientName,props.row.productDetail,props.row.searchDeliveryMonth,props.row.status)"
                class="button"
                type="is-primary"
                native-type="button"
              >発送登録</b-button>
            </b-table-column>
          </template>
          <template slot="detail" slot-scope="props">
            <div class="content">
              <span class="bold">発送先：</span>
              <span>〒{{props.row.postCode}} {{ props.row.address }}</span>
              <div style="height: 10px;" />
              <table style="table-layout: fixed;">
                <template v-for="(items) in props.row.productDetail">
                  <template v-for="(prodItem,index) in items.shoumouList">
                    <!-- 消耗品1~20 -->
                    <tr
                      v-if="prodItem.itemCode"
                      v-bind:key="prodItem.index"
                      v-bind:style="addBorderStyle(index)"
                    >
                      <td>{{ prodItem.name }} ({{ prodItem.itemCode }})</td>
                      <td>{{ items.inspectionKind | inspectionTypeFillter }}</td>
                      <td>
                        <span>
                          <b-checkbox :disabled="true" :value="prodItem.regularDeliveryFlag" />発送
                        </span>
                      </td>
                      <td>
                        <span>
                          <b-checkbox :disabled="true" :value="prodItem.cancelFlag" />キャンセル
                        </span>
                      </td>
                      <td>{{ prodItem.itemCode }}</td>
                      <td>{{ prodItem.name }}</td>
                      <td>{{ prodItem.preDate }}</td>
                      <td style="padding-left:17px;">{{ prodItem.interval }}ヶ月</td>
                      <td>{{ prodItem.count }}EA</td>
                      <td>{{ prodItem.nextDate }}</td>
                    </tr>
                  </template>
                </template>
              </table>
            </div>
          </template>
        </b-table>
        <b-modal v-if="isRegularDisposablesOrderModalActive" :active.sync="isRegularDisposablesOrderModalActive" has-modal-card full-screen>
          <regular-disposables-modal
            v-bind:disposablesByDevice="targetProductDetail"
            v-bind:patientCode="targetPatientCode"
            v-bind:patientName="targetPatientName"
            v-bind:searchDeliveryMonth="searchDeliveryMonth"
            v-bind:role="roleId"
            v-bind:status="status"
            v-on:search-event="search"
          ></regular-disposables-modal>
        </b-modal>
      </div>
      <div class="column" />
      <div>
        <b-button
          v-if="roleId!=2"
          v-on:click="fix"
          class="button is-primary has-text-centered"
          icon-left="truck"
          native-type="button"
        >確定</b-button>
      </div>
    </section>
  </div>
</template>

<script>
import regulardisposablesOderTemplate from "./AppRegularDisposablesOrder";
const dayjs = require('dayjs');

const RegularDisposablesTemplate = {
  components: {
    regularDisposablesOder: regulardisposablesOderTemplate
  },
  props: [
    "disposablesByDevice",
    "patientCode",
    "patientName",
    "searchDeliveryMonth",
    "role",
    "status"
  ],
  data() {
    // 定期消耗品の編集が可能か判定するフラグ
    var activeFlag = true;
    var disabledFlag = false;
    var now = new Date();
    // 次月
    var nextMonth = now.getMonth() + 2;
    if (nextMonth > 12) {
      nextMonth = parseInt(nextMonth % 12);
    }

    // 発送予定月算出
    var beforeDate = new Date(this.searchDeliveryMonth);
    var targetMonth = beforeDate.getMonth() + 1;
    if (targetMonth > 12) {
      targetMonth = parseInt(targetMonth % 12);
    }

    var day = now.getDate();
    const lastCancelDay = this.getShoumouCancelRangeEndDay();

    if (targetMonth == nextMonth) {
      // 発送予定月が次月
      if (day > 5) {
        activeFlag = false;
      }
      if (day > lastCancelDay) {
        disabledFlag = true;
      }
    }

    const disposablesByDeviceTemp = JSON.parse(JSON.stringify(this.disposablesByDevice));

    return {
      activeFlag,
      disabledFlag,
      disposablesByDeviceTemp,
    };
  },
  methods: {
    save: function(event) {
      var childView = this.$refs.regularDisposablesView;
      if (childView.checkDisposablesOrder()) {
        childView.$validator.validateAll().then(validatorResult => {
          if (validatorResult) {
            if (!childView.checkItems()) {
                childView.save().then(result => {
                if (childView.isSuccessEnd()) {
                  this.$emit("search-event");
                  this.$parent.close();
                } else {
                  scrollTo(0, 0);
                }
              });
            }
          } else {
            scrollTo(0, 0);
          }
        });
      } else {
        // エラーメッセージ表示
        this.showErrorMessage(
          "発送期間が1カ月の消耗品は発送できません。<br>" +
            "発送のチェックを外してください。"
        );
        scrollTo(0, 0);
      }
    },
    back: function(event) {
      // this.$emit("search-event");
      this.$parent.close();
    }
  },
  template: `
    <form style="width: 90%;height:30px;margin-left: 5%;margin-top: 1%;">
      <div class="modal-card" style="width: 100%;">
        <section class="modal-card-body" style="width: 100%;height:100%;">
          <regularDisposablesOder
           ref="regularDisposablesView"
           v-bind:disposablesByDevice="disposablesByDeviceTemp"
           v-bind:isSourceInspection="false"
           v-bind:patientCode="patientCode"
           v-bind:patientName="patientName"
           v-bind:roleId="role"
           v-bind:status="status"
           v-bind:isActive="activeFlag"
           v-bind:disabledFlag="disabledFlag"
           v-bind:searchDeliveryMonth="searchDeliveryMonth"
          />
          <div style="height: 10px;" />
        </section>
        <footer style="text-align:center;">
          <b-button
           v-on:click=back
           class="button"
           type="is-primary"
           icon-left="keyboard-backspace"
           native-type="button"
           >戻る</b-button>
          <b-button
           v-if="role!=2 && !disabledFlag"
           v-on:click=save
           class="button"
           type="is-primary"
           native-type="button"
          >登録</b-button>
          <div style="height: 10px;" />
        </footer>
      </div>
    </form>
`
};

export default {
  props: ["value", "searchConditions"],
  name: "AppRegularDissbosablesSearchResult",
  methods: {
    getOfficeName: function(value) {
      return value.split(",");
    },
    search: function(event) {
      this.checkedRows = [];
      // 検索条件の整形
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] = parseInt(
          this.searchConditions.regularDisposablesStatusGroup[val]
        );
      }
      for (var val in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[val] = parseInt(
          this.searchConditions.inspectionKindGroup[val]
        );
      }
      var excuteApi = this.getRegularDisposablesListPOST;
      var successCallBack = this.getRegularDisposablesListSuccess;
      var errorCallBack = this.getRegularDisposablesListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getRegularDisposablesListPOST: function(client) {
      // 発送対象外:2はリクエストに含めないように
      let status = this.searchConditions.regularDisposablesStatusGroup.filter(
        v => v != 2
      );

      return client.apis.apiInspection.getRegularDisposablesListPOST({
        body: {
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          officeCode: this.searchConditions.officeCode,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          staffCode: this.searchConditions.staffCode,
          staffName: this.searchConditions.staffName,
          inspectionType: this.searchConditions.inspectionKindGroup,
          status: status,
          deliveryMonth: this.searchConditions.deliveryMonth
        }
      });
    },
    getRegularDisposablesListSuccess: function(result) {
      //発送対象外(すべての消耗品の定期発送フラグがfalse or 定期発送フラグがtrueで数量が0)かどうかを設定する
      result.obj = this.setUntargetedFlag(result.obj);
      let statusGroup = this.searchConditions.regularDisposablesStatusGroup;
      //ステータスの絞り込みを指定している場合
      if (statusGroup && statusGroup.length > 0) {
        //発送対象外:2を選択している場合
        if (statusGroup.includes(2)) {
          //発送対象外フラグがtrueのもののみ絞り込む
          result.obj = result.obj.filter(row => {
            return statusGroup.includes(row.status) || row.untargetedFlag;
          });
        } else {
          //発送対象外フラグがfalseのもののみ絞り込む
          result.obj = result.obj.filter(row => {
            return !row.untargetedFlag;
          });
        }
      }

      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      for (var val in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[val] =
          this.searchConditions.inspectionKindGroup[val] + "";
      }
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] =
          this.searchConditions.regularDisposablesStatusGroup[val] + "";
      }
    },
    getRegularDisposablesListError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      for (var val in this.searchConditions.inspectionKindGroup) {
        this.searchConditions.inspectionKindGroup[val] =
          this.searchConditions.inspectionKindGroup[val] + "";
      }
      for (var val in this.searchConditions.regularDisposablesStatusGroup) {
        this.searchConditions.regularDisposablesStatusGroup[val] =
          this.searchConditions.regularDisposablesStatusGroup[val] + "";
      }
    },
    regulardisposablesOrder(
      patientCode,
      patientName,
      productDetail,
      searchDeliveryMonth,
      status
    ) {
      this.targetPatientCode = patientCode;
      this.targetPatientName = patientName;
      this.targetProductDetail = productDetail;
      this.searchDeliveryMonth = searchDeliveryMonth;
      this.status = status
      this.isRegularDisposablesOrderModalActive = true;
    },
    fix: async function() {
      //確定
      let fixedflg = false;
      let checkInspectionKind = false;
      let checkDeliveryDate = false;
      let checkConfirmedDate = false;
      let inspectionUncompleteList = new Set();

      // 発送対象外チェック
      var untargetedItems = this.checkedRows.filter(
        value => value.untargetedFlag == true
      );
      // 発送対象外のレコードが選択されている場合
      if (untargetedItems.length > 0) {
        //エラーメッセージ表示
        this.showErrorMessage(
          "発送対象外なので確定できません。" +
            "<br>" +
            "発送対象にする場合は発送にチェックを入れて、" +
            "<br>" +
            "数量を1EA以上にしてください。"
        );
        return;
      }

      if (this.checkedRows.length > 0) {
        // 確定期間チェック
        let today = dayjs().format("YYYYMMDD");
        let confirmedDate = dayjs(this.searchConditions.deliveryMonth + "/05").subtract(1, "month").format("YYYYMMDD");
        if (today > confirmedDate) {
          checkConfirmedDate = true;
        }

        grid_loop: for (let i = 0; i < this.checkedRows.length; i++) {
          //どれかが既にチェックNGとなっている場合はループ終了
          if (fixedflg || checkInspectionKind || checkDeliveryDate || checkConfirmedDate) break;

          if (this.checkedRows[i].status != 0) {
            //確定済の場合、確定させない
            fixedflg = true;
          }

          let tmpDeliveryDate;
          let productDetail = this.checkedRows[i].productDetail;
          for (let j = 0; j < productDetail.length; j++) {
            //どれかが既にチェックNGとなっている場合はループ終了
            if (checkDeliveryDate || checkDeliveryDate) break;

            let diposables = productDetail[j];

            // SMS未点検チェック
            if (!diposables.inspectionCompleted && diposables.inspectionKind != 6) {
              // 発送対象があれば除外リストに追加
              if (diposables.shoumouList.length > 0) {
                const isDelivery = diposables.shoumouList.some((shoumou) => {
                  if (shoumou.itemCode && shoumou.regularDeliveryFlag && shoumou.count > 0) {
                    return true;
                  }
                });
                if (isDelivery) {
                  inspectionUncompleteList.add(this.checkedRows[i].patientCode);
                }
              }
            }

            //発送対象存在チェック
            let deliveryExists = false;
            for (let k = 0; k < diposables.shoumouList.length; k++) {
              if (
                diposables.shoumouList[k] &&
                diposables.shoumouList[k].regularDeliveryFlag
              ) {
                if (!tmpDeliveryDate) {
                  // 基準となる次回供給予定日をセット
                  tmpDeliveryDate = diposables.shoumouList[k].nextDate;
                }
                deliveryExists = true;

                // 点検種別チェック
                if (diposables.inspectionKind != 2 &&
                    diposables.inspectionKind != 6) {
                  //在宅/当社点検以外かつ定期発送にチェックが入っている場合、確定させない
                  checkInspectionKind = true;
                  break grid_loop;
                }

                // 一つでも存在している場合はループ終了
                break;
              }
            }

            if (deliveryExists) {
              // 次回供給予定日チェック
              var checkNextDateListNg = diposables.shoumouList.filter(
                v => v.nextDate != tmpDeliveryDate
              );
              // 定期発送対象(種別が)かつ、次回供給予定日がことなるデータを抽出
              if (checkNextDateListNg && checkNextDateListNg.length > 0) {
                //発送日付が異なる場合は確定させない
                checkDeliveryDate = true;
                break grid_loop;
              }
            }
          }
        }
        if (fixedflg) {
          //エラーメッセージ表示
          this.showErrorMessage(
            "確定済のレコードが含まれています。<br>未確定のレコードを選択してください。"
          );
        } else if (checkInspectionKind) {
          //エラーメッセージ表示
          this.showErrorMessage(
            "点検種別が「在宅/当社点検」、「フリーメンテ」以外は発送できません。<br>消耗品発送登録画面で発送のチェックを外して<br>登録し直してください。"
          );
        } else if (checkDeliveryDate) {
          //エラーメッセージ表示
          this.showErrorMessage(
            "次回供給予定日が異なる消耗品があります。<br>消耗品発送登録画面で指定納期を設定してください。"
          );
        } else if (checkConfirmedDate) {
          //エラーメッセージ表示
          this.showErrorMessage(
            this.searchConditions.deliveryMonth + " 発送分の確定可能期間を超過しています。"
          );
        } else {
          if (inspectionUncompleteList.size > 0) {
            let message = "SMSで点検未実施の情報が含まれています。\n以下の情報を除いて確定を行いますか？";
            for (const patientCode of inspectionUncompleteList) {
              message += "\n・患者コード: " + patientCode;
            }
            const comfirmCancel = await this.showComfirmMessage(message);
            if (comfirmCancel) {
              // 確定対象から除外
              for (const patientCode of inspectionUncompleteList) {
                let index;
                this.checkedRows.filter((data, i) => {
                  if (patientCode == data.patientCode) {
                    index = i;
                    return true;
                  }
                });
                if (index >= 0) {
                  this.checkedRows.splice(index, 1);
                }
              }

              if (this.checkedRows.length == 0) {
                this.showErrorMessage("確定可能な患者がありませんでした。");
                return;
              }
            } else {
              return;
            }
          }

          var excuteApi = this.setRegularDisposablesStatusPOST;
          var successCallBack = this.setRegularDisposablesStatusPOSTSuccess;
          var errorCallBack = this.setRegularDisposablesStatusPOSTError;
          // WebAPI Call
          return this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      } else {
        //エラーメッセージ表示
        this.showErrorMessage("患者を選択してください。");
      }
    },
    setRegularDisposablesStatusPOST: function(client) {
      var patientCodeList = [];
      for (var i = 0; i < this.checkedRows.length; i++) {
        patientCodeList.push(this.checkedRows[i].patientCode);
      }
      return client.apis.apiInspection.setRegularDisposablesStatusPOST({
        body: {
          deliveryMonth: this.searchConditions.deliveryMonth,
          patientCodeList: patientCodeList
        }
      });
    },
    setRegularDisposablesStatusPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.successEndFlg = true;
      //もう一回検索
      this.search();
    },
    setRegularDisposablesStatusPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.successEndFlg = false;
    },
    doReturn: function(event) {
      this.$router.push({
        name: "AppRegularDisposablesSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
    setUntargetedFlag: function(responseData) {
      responseData.forEach(row => {
        let sendExists = false;

        for (const product of row.productDetail) {
          for (const shoumou of product.shoumouList) {
            // codeありかつcount > 0 かつ deliveryFlagがtrueのものが一つでもある場合
            // 発送対象となりループを抜ける
            if (
              shoumou.itemCode &&
              shoumou.count > 0 &&
              shoumou.regularDeliveryFlag
            ) {
              sendExists = true;
              break;
            }
          }
          if (sendExists) {
            break;
          }
        }
        row.untargetedFlag = !sendExists;
      });
      return responseData;
    },
    addBorderStyle: function(index) {
      if (index == 0) {
        return "border-top: solid 2px; width:100%;";
      } else {
        return "border-top: solid 2px; width:100%; border-color:lightgrey;";
      }
    }
  },
  data() {
    var data = [];
    var officeMaster = [];
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var searchDeliveryMonth;
    var status
    return {
      data,
      officeMaster,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      isRegularDisposablesOrderModalActive: false,
      checkedRows: [],
      userInfo,
      roleId,
      targetProductDetail: [],
      targetPatientCode: "",
      targetPatientName: "",
      searchDeliveryMonth,
      status
    };
  },
  filters: {
    officeFilter: function(value) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    }
  },
  computed: {
    getSearchConditions() {
      return this.searchConditions;
    }
  },
  watch: {},
  mounted: function() {},
  components: {
    "regular-disposables-modal": RegularDisposablesTemplate
  }
};
</script>

<style lang="scss" scoped>
// 文字デザイン
.bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/AppRegularDisposablesSearchResult.vue